export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "openInBrowser": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvrir le MNG dans le navigateur"])}
      },
      "en": {
        "openInBrowser": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open MNG in the browser"])}
      }
    }
  })
}
